import { useMutation } from '@tanstack/react-query'

import { apiClient } from '../../lib/client.js'

/** Download booking reservation contract PDF (customer endpoint) */
export const useDownloadMyBookingReservationContractPdfMutation = () =>
  useMutation({
    mutationFn: async (bookingId: string): Promise<Blob> => {
      const response = await apiClient.client.get<Blob>(
        `/me/bookings/${bookingId}/reservation-contract-pdf`,
        { responseType: 'blob' }
      )
      return response.data
    },
  })
